import * as Asset from './asset';

export default {
    ...Asset
}



// WEBPACK FOOTER //
// ./src/helper/index.js